var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73901 14.5202C4.73901 14.8742 5.02302 15.1603 5.37503 15.1603H10.6232C10.9752 15.1603 11.2592 14.8742 11.2592 14.5202V10.6001H4.73901V14.5202ZM15.3614 0.839722H0.636853C0.146835 0.839722 -0.159176 1.37374 0.086833 1.79976L4.513 9.32003H11.4893L15.9154 1.79976C16.1574 1.37374 15.8514 0.839722 15.3614 0.839722Z",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedFilter);
export default __webpack_public_path__ + "static/media/advanced_filter.16aaf5ba67bb8bdc1885da336923b607.svg";
export { ForwardRef as ReactComponent };